@if (isLoading) {
  <mat-spinner diameter="35" color="accent"></mat-spinner>
} @else {
  <ng-content></ng-content>
}
